import { Logout, UserMenu } from 'react-admin'
import { ProfileMenuItem } from './MyProfileMenuItem'

export const MyUserMenu = (props: any) => (
  <UserMenu {...props}>
    <ProfileMenuItem />
    <Logout />
  </UserMenu>
)
